import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface QuestionnaireResponseState {
  questionnaireResponses: Record<string, QuestionnaireResponse | undefined>;
}

const initialState: QuestionnaireResponseState = {
  questionnaireResponses: {},
};

export const questionnaireResponseSlice = createSlice({
  name: "questionnaireResponses",
  initialState,
  reducers: {
    setNewbornPostpartumQuestionnaireResponses: (
      state,
      action: PayloadAction<Record<string, QuestionnaireResponse | undefined>>,
    ) => {
      state.questionnaireResponses = action.payload;
    },
    updateNewbornPostpartumQuestionnaireResponse: (
      state,
      action: PayloadAction<{
        questionnaireName: string;
        questionnaireResponse: QuestionnaireResponse | undefined;
      }>,
    ) => {
      state.questionnaireResponses[action.payload.questionnaireName] =
        action.payload.questionnaireResponse;
    },
  },
});

export const {
  setNewbornPostpartumQuestionnaireResponses,
  updateNewbornPostpartumQuestionnaireResponse,
} = questionnaireResponseSlice.actions;

// Selectors
export const selectAllNewbornPostpartumQuestionnaireResponses = (state: RootState) =>
  state.newbornPostpartum.questionnaireResponses;

export const selectNewbornPostpartumQuestionnaireResponseByQuestionnaireName = (
  state: RootState,
  questionnaireName: string,
) => state.newbornPostpartum.questionnaireResponses[questionnaireName];

export default questionnaireResponseSlice.reducer;
